import { render, staticRenderFns } from "./StrategicPartnerships.vue?vue&type=template&id=6fe0e67a&scoped=true"
import script from "./StrategicPartnerships.vue?vue&type=script&lang=js"
export * from "./StrategicPartnerships.vue?vue&type=script&lang=js"
import style0 from "./StrategicPartnerships.vue?vue&type=style&index=0&id=6fe0e67a&prod&scoped=true&lang=scss"
import style1 from "./StrategicPartnerships.vue?vue&type=style&index=1&id=6fe0e67a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe0e67a",
  null
  
)

export default component.exports